/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isUndefined } from "@adapptio/lib-shared";
import { getOwnerWindow } from "./getOwnerWindow";

export function isShadowRoot(node: unknown): node is ShadowRoot {
	if (isUndefined(ShadowRoot)) {
		return false;
	}

	return node instanceof ShadowRoot || node instanceof getOwnerWindow(node as Node)["ShadowRoot"];
}
